// import { useState } from 'react'
import Pagination from '../Pagination/Pagination'
import TableV1 from '../Resources/TableV1/TableV1'
import TitleContainer from '../Resources/TitleContainer/TitleContainer'
import classes from './Buyers.module.css'

export default function Buyers({ buyers, pageSkip, setPageSkip, pageAll, setCheck, check }) {
    // const [activePopUp, setActivePopUp] = useState(false)

    return (
        <div className={classes.wrapper}>
            {/* <p className={classes.txt}> Buyer List ({pageAll})</p> */}
            <TitleContainer title={'Buyer List'} count={pageAll} isCount={true} />
            <TableV1>
                <thead>
                    <tr className={`${classes.tableRow}`}>
                        <th>SL</th>
                        <th>Buyer ID</th>
                        <th>Buyer Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Country</th>
                        <th>Company Name</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {buyers &&
                        buyers.map((data, index) => (
                            <tr className={classes.row} key={index}>
                                <td>{index + 1}</td>
                                <td>{'B-' + data.Buyer.buyer_full_id}</td>
                                <td>{data.User.name}</td>
                                <td>{data.User.email}</td>
                                <td>{data.User.phone}</td>
                                <td>{data.Buyer.country}</td>
                                <td>{data.Buyer.company_name || '--'}</td>

                                <td>--</td>
                            </tr>
                        ))}
                </tbody>
            </TableV1>

            {/* {show && <Edit setShow={setShow} />} */}
            {/* {show && <PopUP setShow={setShow} userId={userID} isActive={isActive} />} */}

            <Pagination pageSkip={pageSkip} setPageSkip={setPageSkip} listItem={buyers} pageAll={pageAll} />
        </div>
    )
}
